module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.error || _vm.success || _vm.warning || _vm.info) ? _c('div', {
    class: _vm.customClass
  }, [_c('br'), _vm._v(" "), _c('el-alert', {
    attrs: {
      "title": _vm.error || _vm.success || _vm.warning || _vm.info,
      "type": _vm.type,
      "closable": false,
      "show-icon": true
    }
  }), _vm._v(" "), _c('br')], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a94dcff0","hasScoped":false}!./src/app/components/form/message/message.html
// module id = 3106
// module chunks = 1